export const STORE = {
    STRIPE: 'stripe',
    YOOMONEY: 'yoomoney',
}
